module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/landing-page-headshot/landing-page-headshot@1x.png"